import { routes as routesAlternatives } from "@Alternatives/Alternatives/routes";
import { routes as routesAttributes } from "@Alternatives/Attributes/routes";
import { routes as routesAlternativesLists } from "@Alternatives/AlternativesLists/routes";
import { routes as routesForms } from "@Alternatives/Forms/routes";
import { routes as routesAssignments } from "@Alternatives/Assignments/routes";

import Notifications_NotificationsPage from "@Alternatives/Notifications/Pages/NotificationsPage.vue";
import AlternativesViews_ListsPage from "@Alternatives/AlternativesViews/Pages/ListsPage.vue";

export const routes = [
    ...routesAlternatives,
    ...routesAttributes,
    ...routesAlternativesLists,
    ...routesForms,
    ...routesAssignments,
    {
        path: "/pp/notifications/:workspaceId/:projectId",
        component: Notifications_NotificationsPage
    },
    {
        path: "/pp/lists-manager/:workspaceId/:projectId",
        component: AlternativesViews_ListsPage
    },
]
